const styles = () => ({
  subHeader: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold',
    textAlign: 'center'
  }
});

export default styles;